import { create } from 'zustand';

type SsoProvider = 'google' | 'apple';

type SsoSessionState = {
  idToken: string | null;
  provider: SsoProvider | null;
  firstName: string | null;
  lastName: string | null;
  setSsoSession: (
    provider: SsoProvider,
    idToken: string,
    firstName?: string,
    lastName?: string,
  ) => void;
  clearSsoSession: () => void;
};

export const useSsoSessionStore = create<SsoSessionState>((set) => ({
  idToken: null,
  provider: null,
  firstName: null,
  lastName: null,
  setSsoSession: (provider, idToken, firstName, lastName) =>
    set({
      provider,
      idToken,
      firstName: firstName ?? null,
      lastName: lastName ?? null,
    }),
  clearSsoSession: () =>
    set({ provider: null, idToken: null, firstName: null, lastName: null }),
}));
